import type { IRTJournalSchema } from "~/types/models/ResearchTopic.model";
import type { IJournal, IJournalImpactMetrics } from "../types";
import { ArticleTypeModel2Interface } from "./ArticleTypeModel2Interface";
import { TaxonomyModel2Interface } from "./TaxonomyModel2Interface";
import { JournalSectionSchema2Interface } from "./JournalSectionSchema2Interface";
import type {
  IImpactMetricsSchema,
  IJournalSchema
} from "~/types/models/Journal.model";

export const JournalSchema2Interface = (
  journalSchema: IJournalSchema,
  rtJournalSchema: IRTJournalSchema,
  tenantName: string
): IJournal => {
  const journalTitle = rtJournalSchema.Title.toLowerCase().includes(
    "young minds"
  )
    ? rtJournalSchema.Title.replace("Frontiers in", "Frontiers for")
    : rtJournalSchema.Title.replace("Frontiers in", `${tenantName} in`);

  return {
    articleTypes: ArticleTypeModel2Interface(journalSchema?.ArticleTypes),
    id: journalSchema.JournalId,
    title: journalTitle,
    slug: journalSchema.Slug,
    impactMetrics: mapImpactMetrics(journalSchema?.ImpactMetrics),
    isOpenForSubmission: journalSchema.OpenForSubmission || false,
    isOnline: journalSchema.Online,
    isPrimary: rtJournalSchema.IsPrimary,
    specialtyId: rtJournalSchema.SpecialtyId,
    taxonomy: TaxonomyModel2Interface(journalSchema?.Taxonomies),
    sections: rtJournalSchema.Sections?.map((section) => {
      const sectionDetailIndex = journalSchema.Sections.findIndex(
        (sectionDetail) => sectionDetail.SectionId === section.SectionId
      );
      const sectionDetail = journalSchema.Sections[sectionDetailIndex];
      return JournalSectionSchema2Interface(
        sectionDetail,
        tenantName,
        section.IsPrimary
      );
    })
  };
};

function mapImpactMetrics(
  impactMetricsSchema: IImpactMetricsSchema[] | undefined
): IJournalImpactMetrics {
  if (!impactMetricsSchema) impactMetricsSchema = [];

  const impactFactor =
    impactMetricsSchema.find((im) => im.Provider.Code === "ImpactFactor")
      ?.Value || 0;
  const citeScore =
    impactMetricsSchema.find((im) => im.Provider.Code === "CiteScore")?.Value ||
    0;

  return { impactFactor, citeScore };
}
